import * as userTypes from '../types/tourInicialTypes'

export const enableTour = (tourState, tourPreferences) => ({
    type: userTypes.setState,
    tourState: tourState,
    tourPreferences: tourPreferences
});
